const name = "@prismicio/adapter-next";
export {
  name
};
//# sourceMappingURL=package.json.js.map
